import { classNames } from "primereact/utils";

import { DIALOG_HEADER_ROOT_CLASS } from "./dialog-header.constants";
import type { DialogHeaderProps, DialogHeaderViewModel } from "./types-dialog-header";

/** ViewModel do `DialogHeader`: aplica o tom padrão, junta a classe estável do tema à da tela e separa o resto da raiz. */
export function useDialogHeader({
  title,
  subtitle,
  icon,
  tone = "neutral",
  classNames: parts,
  className,
  ...rest
}: DialogHeaderProps): DialogHeaderViewModel {
  return {
    title,
    subtitle,
    icon,
    tone,
    classNames: parts ?? {},
    rootClassName: classNames(DIALOG_HEADER_ROOT_CLASS, className),
    rest,
  };
}
